import { debounce } from '@/utilities/gating.js'

export const createResizeObserver = (callback, latency = 0) => {
  return new ResizeObserver(
    debounce((entries) => {
      for (const entry of entries) {
        if (entry.contentBoxSize) {
          const width = entry.contentBoxSize
            ? entry.contentBoxSize[0]?.inlineSize || entry.contentBoxSize.inlineSize
            : entry.contentRect.width
          const height = entry.contentBoxSize
            ? entry.contentBoxSize[0]?.blockSize || entry.contentBoxSize.blockSize
            : entry.contentRect.height
          // console.debug('[resizeObserver]: contentBox (w, h)=', width, height)
          callback(width, height)
        }
      }
    }, latency)
  )
}

export const createMutationObserver = (callback) => {
  return new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        console.debug('[mutationObserver]: A child node has been added or removed.')
        callback({ type: mutation.type })
      } else if (mutation.type === 'attributes') {
        console.debug(`[mutationObserver]: The ${mutation.attributeName} attribute was modified.`)
        callback({ type: mutation.type, attributeName: mutation.attributeName })
      }
    })
  })
}

export const observe = (element, observer, options = {}) => {
  if (element && observer) {
    observer.observe(element, options)
  } else {
    console.warn('[observe]: element or observer is null!')
  }
}

export const disconnect = (observer) => {
  if (observer) {
    observer.disconnect()
  } else {
    console.warn('[disconnect]: observer is null!')
  }
}
